var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"width":"80%"},scopedSlots:_vm._u([{key:"default",fn:function({ isActive }){return [_c('v-card',[_c('v-card-title',[_vm._v("Update Data Main Sosprog")]),_c('v-card-text',{staticClass:"ff-email-wrapper"},[_c('ValidationObserver',{ref:"firstForm",scopedSlots:_vm._u([{key:"default",fn:function({ handleSubmit }){return [_c('form',{attrs:{"autocomplete":"off"},on:{"submit":function($event){$event.preventDefault();return handleSubmit(_vm.onSubmit)}}},[(_vm.loading == false)?_c('v-row',{staticClass:"px-5 py-5",attrs:{"lg":"12"}},[_c('v-col',{staticClass:"form-separator",attrs:{"md":"12"}},[_c('h4',[_vm._v("Tanggal Sosialisasi")])]),_c('v-col',{attrs:{"lg":"6"}},[_c('geko-input',{attrs:{"item":{
                                    label: 'Tanggal',
                                    validation: ['required'],
                                    type: 'date',
                                    setter: 'date',
                                }},model:{value:(_vm.formData.form_date),callback:function ($$v) {_vm.$set(_vm.formData, "form_date", $$v)},expression:"formData.form_date"}})],1),_c('v-col',{attrs:{"lg":"6"}},[_c('geko-input',{attrs:{"item":{
                                    label: 'Tahun Program',
                                    validation: ['required'],
                                    type: 'select',
                                    setter: 'program_year',
                                    option: {
                                        default_options: _vm.$_config.programYear.options.map(
                                            (x) => {
                                                return {
                                                    label: x,
                                                    code: x,
                                                };
                                            }
                                        ),
                                        list_pointer: {
                                            label: 'label',
                                            code: 'code',
                                            display: ['label'],
                                        },
                                    },
                                }},model:{value:(_vm.formData.program_year),callback:function ($$v) {_vm.$set(_vm.formData, "program_year", $$v)},expression:"formData.program_year"}})],1),_c('v-col',{staticClass:"form-separator",attrs:{"md":"12"}},[_c('h4',[_vm._v("Lokasi Desa")])]),_c('v-col',{attrs:{"lg":"6"}},[_c('geko-input',{attrs:{"item":{
                                    label: 'Management Unit',
                                    validation: ['required'],
                                    col_size: 6,
                                    type: 'select',
                                    setter: 'mu_no',
                                    api: 'GetManagementUnit',
                                    default_label: _vm.formData.managementunits_name,
                                    option: {
                                        getterKey: 'data.result',
                                        list_pointer: {
                                            code: 'mu_no',
                                            label: 'name',
                                            display: ['name'],
                                        },
                                    },
                                }},model:{value:(_vm.formData.mu_no),callback:function ($$v) {_vm.$set(_vm.formData, "mu_no", $$v)},expression:"formData.mu_no"}})],1),_c('v-col',{attrs:{"lg":"6"}},[_c('geko-input',{attrs:{"disabled":!_vm.formData.mu_no,"item":{
                                    label: 'Target Area',
                                    validation: ['required'],
                                    col_size: 6,
                                    type: 'select',
                                    setter: 'target_area',
                                    api: 'GetTargetArea',
                                    default_label: _vm.formData.target_areas_name,
                                    param: {
                                        mu_no: _vm.formData.mu_no,
                                    },
                                    option: {
                                        getterKey: 'data.result',
                                        list_pointer: {
                                            code: 'area_code',
                                            label: 'name',
                                            display: ['name'],
                                        },
                                    },
                                }},model:{value:(_vm.formData.target_area),callback:function ($$v) {_vm.$set(_vm.formData, "target_area", $$v)},expression:"formData.target_area"}})],1),_c('v-col',{attrs:{"lg":"6"}},[_c('geko-input',{attrs:{"disabled":!_vm.formData.target_area || !_vm.formData.program_year,"item":{
                                        label: 'Desa',
                                        validation: ['required'],
                                        col_size: 6,
                                        type: 'select',
                                        setter: 'village',
                                        api: 'new-utilities/desas',
                                        default_label: _vm.formData.desas_name,
                                        param: {
                                            program_year: _vm.formData.program_year,
                                            kode_ta: _vm.formData.target_area,
                                        },
                                        option: {
                                            getterKey: 'data',
                                            list_pointer: {
                                                code: 'kode_desa',
                                                label: 'name',
                                                display: ['name', 'kecamatans_name'],
                                            },
                                        },
                                    }},on:{"selected":function($event){return _vm.onChangeVillage($event)}},model:{value:(_vm.formData.village),callback:function ($$v) {_vm.$set(_vm.formData, "village", $$v)},expression:"formData.village"}})],1),(_vm.formData.village)?_c('v-col',{attrs:{"lg":"6"}},[_c('geko-input',{attrs:{"item":{
                                    label: 'Project',
                                    validation: ['required'],
                                    type: 'select-radio',
                                    setter: 'projectPurpose',
                                    option: {
                                        list_pointer: {
                                            label: 'label',
                                            code: 'code',
                                            display: ['label'],
                                        },
                                        default_options: [
                                            {
                                                label: 'Carbon',
                                                code: 2,
                                            },
                                            {
                                                label: 'Non Carbon',
                                                code: 3,
                                            },
                                        ],
                                    },
                                }},model:{value:(_vm.projectPurpose),callback:function ($$v) {_vm.projectPurpose=$$v},expression:"projectPurpose"}})],1):_vm._e(),_c('v-col',{attrs:{"md":"6"}},[_c('geko-input',{attrs:{"item":{
                                    label: 'Foto Dokumentasi 1 (Kegiatan)',
                                    validation: ['required'],
                                    type: 'upload',
                                    api: 'sosialisasi_program/upload.php',
                                    directory: 'photos/documentations',
                                    upload_type: 'image/*',
                                    setter: 'photo_documentation1',
                                    view_data: 'photo_documentation1',
                                    require_gps: true,
                                    option: {
                                        label_hint:
                                            'Klik gambar untuk memilih berkas yang akan diunggah',
                                        max_size: 5,
                                        max: 3,
                                        multiple: true,
                                    },
                                }},model:{value:(_vm.formData.photo_documentation1),callback:function ($$v) {_vm.$set(_vm.formData, "photo_documentation1", $$v)},expression:"formData.photo_documentation1"}})],1),_c('v-col',{attrs:{"md":"6"}},[_c('geko-input',{attrs:{"item":{
                                    label: 'Foto Dokumentasi 2 (Absensi)',
                                    validation: ['required'],
                                    type: 'upload',
                                    api: 'sosialisasi_program/upload.php',
                                    directory: 'photos/documentations',
                                    upload_type: 'image/*',
                                    setter: 'photo_documentation2',
                                    view_data: 'photo_documentation2',
                                    require_gps: true,
                                    option: {
                                        label_hint:
                                            'Klik gambar untuk memilih berkas yang akan diunggah',
                                        max_size: 5,
                                        max: 3,
                                        multiple: true,
                                    },
                                }},model:{value:(_vm.formData.photo_documentation2),callback:function ($$v) {_vm.$set(_vm.formData, "photo_documentation2", $$v)},expression:"formData.photo_documentation2"}})],1)],1):_vm._e(),_c('v-row',[_c('v-col',{staticClass:"d-flex flex-row justify-content-center",attrs:{"lg":"12"}},[_c('v-btn',{staticClass:"d-flex flex-row align-items-center",attrs:{"variant":"warning","type":"submit"}},[_c('v-icon',[_vm._v("mdi-pencil-outline")]),_c('span',[_vm._v("Perbarui Data")])],1)],1)],1)],1)]}}],null,true)})],1)],1)]}}]),model:{value:(_vm.isOpen),callback:function ($$v) {_vm.isOpen=$$v},expression:"isOpen"}})
}
var staticRenderFns = []

export { render, staticRenderFns }